import role4Schema from '../../../../assets/forms/role-120000.form.json';
import { SHEET_KEYS } from '../../../models/sheet-keys';
import { getVisibleDirectorCount } from '../validators/role4-directors-report.rules';
import { makeDirectorCountProjector } from './make-director-count-projector';

/**
 * Strips role 4's hidden director fields at submit. A director triplet
 * (Name/Type/IdentificationNumber for directors 2–5) is visible only when its
 * `ui.directorNumber <= NumberOfDirectorsSigningDirectorsReport`; anything above
 * the count is stale and must not be submitted as an XBRL fact. Reuses
 * `getVisibleDirectorCount` — the SAME resolver the component's shouldShowField
 * and the pure validator use — so visibility cannot drift between editor and
 * submit.
 *
 * A blank/absent count resolves to ZERO, so every director field is stripped.
 * That claim of parity was FALSE between 2026-07-28 and 2026-07-29: the resolver
 * fell back to 2 while the component fell back to 0, so a cleared count rendered
 * nothing on screen yet still shipped directors 1–2. Do not reintroduce a
 * non-zero blank fallback here without changing the component in the same edit.
 *
 * NOTE: role 4 does NOT tag `ssmt:NameOfFirstDirectorWhoSignedDirectorsReport`
 * with `ui.directorNumber` (the component compensates via `directorNumberOf`),
 * so this projector leaves that one field in place. It is director 1's name and
 * is only ever hidden by a fully-cleared count — see the schema-debt note in
 * `docs/specifications/sheets/04_directors-report.md`.
 */
export const role4DirectorsReportProjector = makeDirectorCountProjector(
  SHEET_KEYS.directorsReport,
  getVisibleDirectorCount,
  role4Schema.controls as Array<{ qname: string; ui?: { directorNumber?: number } }>
);
